import * as Sentry from '@sentry/react';
import { action, runInAction, makeObservable } from "mobx";
import moment from "moment";
import Configuracao from "./Configuracao";

class Ambiente {
    static _requisicoes = [];

    urlBackendMinuta = '';
    urlWebDAV = '';
    urlEnvelope = '';
    urlBackendGE = '';
    urlLogus = '';
    urlAssistenteMinuta = '';
    urlJurisprudencia = '';
    urlPJe = '';
    urlEsij = '';
    urlERec = '';
    appNome = '';
    appBranch = '';
    appBuild = '';
    appVersao = '';
    dataBuild = '';
    ambientes = {
        development: 'desenvolvimento',
        production: 'produção',
        homologation: 'homologação',
        beta: 'beta',
        local: 'local',
        qualidade: 'qualidade'
    }

    adicionarRequisicao = (url, cancelFunction) => {
        Ambiente._requisicoes.push({ url: url, cancelar: cancelFunction });
    }

    removerRequisicao = url => {
        const index = Ambiente._requisicoes.findIndex(requisicao => requisicao.url === url);
        index !== -1 && Ambiente._requisicoes.splice(index, 1);
    }

    cancelarRequisicoes = () => {
        Ambiente._requisicoes.forEach(requisicao => requisicao.cancelar && requisicao.cancelar());
        Ambiente._requisicoes = [];
    }

    zerarRequisicoes = () => {
        Ambiente._requisicoes = [];
    }

    constructor() {
        makeObservable(this, {
            criarAmbiente: action
        });
    }

    async criarAmbiente() {
        return new Promise<void>((resolve, reject) => {
            (async () => {
                try {
                    const url = window.location.href;

                    const responseEnv = await fetch(Configuracao.CONFIG_URL);
                    const baseUrl = await responseEnv.json();
                    const responseParamsAppJson = await fetch(Configuracao.APP_JSON);
                    const parametrosAppJson = await responseParamsAppJson.json();
                    runInAction(() => {
                        this.urlLogus = baseUrl['URL_LOGUS'];
                        this.appNome = parametrosAppJson["app.nome"];
                        this.appBranch = parametrosAppJson["app.build"];
                        this.appBuild = this.ambientes[process.env.NODE_ENV];
                        this.dataBuild = parametrosAppJson["dataBuild"];
                        this.appVersao = parametrosAppJson["app.versao"];
                    })
                    const responseConfigSessao = await fetch(this.urlLogus + '/configs');
                    const configSessao = await responseConfigSessao.json();

                    try {
                        if (url.includes('.bet.') || url.includes('.prd.') || url.includes('.tst.jus.br')) {
                            console.info("Iniciando sentry")
                            Sentry.init({
                                dsn: "https://855a4309c0d64fbba4cd19b561e34729@sentry.tst.jus.br/14",
                                environment: process.env.NODE_ENV,
                                release: `GE-${this.appVersao}-${moment(this.dataBuild).format('YYYY-MM-DD-HH.mm')}`,
                                integrations: [
                                    Sentry.browserTracingIntegration(),
                                    Sentry.replayIntegration({
                                        maskAllText: false,
                                        maskAllInputs: false,
                                        blockAllMedia: false
                                    }),
                                    Sentry.captureConsoleIntegration({
                                        levels: ['error']
                                    })
                                ],
                                tracesSampleRate: 1.0,
                                replaysSessionSampleRate: 0.01,
                                replaysOnErrorSampleRate: 1.0,

                            });
                        }
                    } catch (err) {
                        console.error("Erro ao iniciar o sentry", err);
                    }

                    try {
                        const clarityId = baseUrl['CLARITY_ID'];
                        if (clarityId) {
                            console.info("Iniciando clarity")
                            this.iniciarClarity(clarityId);
                        }
                    } catch (err) {
                        console.error("Erro ao iniciar o clarity", err);
                    }

                    runInAction(() => {
                        this.urlBackendMinuta = baseUrl['URL_MINUTA'];
                        this.urlWebDAV = baseUrl['URL_WEB_DAV'];
                        this.urlBackendGE = baseUrl['URL_BACKEND_GE'];
                        this.urlJurisprudencia = baseUrl['URL_JURISPRUDENCIA'];
                        this.urlPJe = baseUrl['URL_PJE'];
                        this.urlEsij = baseUrl['URL_ESIJ'];
                        this.urlAssistenteMinuta = baseUrl['URL_ASSISTENTE_MINUTA'];
                        this.urlERec = baseUrl['URL_EREC'];
                        this.urlEnvelope = baseUrl['URL_ENVELOPE'];
                        this.urlLogus = configSessao.urlLogin;
                        resolve();
                    });

                } catch (erro) {
                    reject(erro);
                }
            })();
        })
    }

    get branch(): string {
        if (this.urlBackendMinuta.includes('hml.rede.tst')) {
            return this.ambientes.homologation;
        } else if (this.urlBackendMinuta.includes('bet.rede.tst')) {
            return this.ambientes.beta;
        } else if (this.urlBackendMinuta.includes('dev.rede.tst')) {
            return this.ambientes.development;
        } else if (this.urlBackendMinuta.includes('prd.rede.tst') || this.urlBackendMinuta.includes('tst.jus.br')) {
            return this.ambientes.production;
        } else if (this.urlBackendMinuta.includes('qua.rede.tst')) {
            return this.ambientes.qualidade;
        } else {
            return this.ambientes.local;
        }


    }

    get isDesenvolvimento(): boolean {
        return this.branch === this.ambientes.development;
    }

    get isHomologacao(): boolean {
        return this.branch === this.ambientes.homologation;
    }

    get isBeta(): boolean {
        return this.branch === this.ambientes.beta;
    }

    get isProducao(): boolean {
        return this.branch === this.ambientes.production;
    }

    get isQualidade(): boolean {
        return this.branch === this.ambientes.qualidade;
    }

    private iniciarClarity(projectId: string) {
        /* eslint-disable */
        (function (c: any, l: Document, a: string, r: string, i: string) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
            const t = l.createElement(r) as HTMLScriptElement;
            t.async = true;
            t.src = "https://www.clarity.ms/tag/" + i;
            const y = l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", projectId);
        /* eslint-enable */
    }

}

// const instance = new Ambiente();
// Object.freeze(instance);
export default new Ambiente();
